
<template>
  <b-card no-body >
    <b-card-body>
      <div class="d-flex justify-content-between  flex-wrap">
        <!-- Registar Tipo  -->
        <b-form-group
            label-for="filterInput"
            class="mb-0"
        >
          <b-button
              variant="gradient-primary"
              size="sm"
              class="mr-1"
              @click="traerActividad"
          >
            <feather-icon
                icon="RefreshCwIcon"
            />
          </b-button>
          <b-button
              variant="gradient-success"
              size="sm"
              class="mr-1"
              v-b-modal.modal-importar

          >
            <font-awesome-icon icon="fa-solid fa-file-excel"/> &nbsp;&nbsp;
            <span class="align-middle">Importar</span>
          </b-button>
          <b-button
              variant="gradient-secondary"
              size="sm"
              @click="descargarFilePlantilla"
          >

            <span v-if="loadingPlantilla"> Generando Archivo..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
            <span v-else>
              <feather-icon
                  icon="ExternalLinkIcon"
                  class="mr-50"
              />
              <span class="align-middle">Plantilla</span>
            </span>
          </b-button>
        </b-form-group>

        <!-- filter -->
        <b-form-group
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Buscar"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Borrar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </div>
    </b-card-body>

    <b-table
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="cPaginacion"
        :busy="loading"
        show-empty
        empty-text="No se encontraron datos en esta tablas."
        emptyFilteredText="No se encontraron datos con los parámetros ingresados."
    >
      <template #table-busy>
        <div class="text-center text-dark my-1">
          <b-spinner class="align-middle"></b-spinner> &emsp;
          <strong>Obteniendo datos...</strong>
        </div>
      </template>

      <template #cell(estado)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>

      <template #cell(acciones)="data">
        <div class="text-nowrap">

          <feather-icon
              :id="`btn_${data.item.id}_eliminar`"
              icon="Trash2Icon"
              size="16"
              @click="eliminarRegistro(data.item.id, data.item.nombre_trabajador)"
          />
          <b-tooltip
              title="Eliminar registro"
              :target="`btn_${data.item.id}_eliminar`"
          />
        </div>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

    <b-modal
        id="modal-importar"
        ref="modal_importar"
        title="Importar Datos Masivos"
        ok-title="Importar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="md"
        :cancel-disabled="loadingCarga"
        :ok-disabled="loadingCarga||!archivo_excel"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok="importarOk"
    >
      <div v-if="loadingCarga"  align="center">
        <p>Importando datos ... </p>
        <b-spinner label="Importando ..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioImportarTemas" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="enviarExcelMasivos">
          <b-row>
            <b-col lg="12">
              <b-form-group
                  label="Archivo"
                  label-for="archivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Archivo"
                    vid="archivo"
                    rules=""
                >
                  <b-form-file
                      id="archivo"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
  </b-card>
</template>

<script>
import axiosIns from '@axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol, BSpinner,
  BDropdown, BDropdownItem,
  BCardHeader, BCardTitle, BCardSubTitle,
  Card, BFormFile, BFormTextarea, BButtonGroup, BSidebar,
  VBToggle, BForm, BFormDatepicker, BLink, BInputGroupPrepend, BDropdownForm, BDropdownHeader, BDropdownDivider,
  BFormRadio, BFormRadioGroup,
  BAlert, BFormCheckbox, BCardText,
} from 'bootstrap-vue'
import flatPickr from "vue-flatpickr-component";
import axios from "axios";
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { Modal, Button } from 'bootstrap'
import {VueGoodTable} from "vue-good-table";
import VueApexCharts from "vue-apexcharts";
import VueContext from "vue-context";
import {useToggle} from "@vueuse/core";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    flatPickr,
    BFormCheckbox,
    BCardText,
    VueGoodTable,
    BDropdown,
    BDropdownItem,
    VueApexCharts,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    apexchart: VueApexCharts,
    Modal,
    ValidationProvider,
    ValidationObserver,
    VueContext,
    BLink,
    BFormFile,
    BFormTextarea,
    BButtonGroup,
    BSidebar,
    BFormDatepicker,
    BInputGroupPrepend,
    BForm,
    BDropdownForm,
    BDropdownHeader,
    BDropdownDivider,
    BFormRadio,
    BFormRadioGroup,
    BAlert,
    useToggle
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      loading:false,
      estadoModal: false,
      showCboGrupo:true,
      showTxtGrupo:false,
      showCboCultivo:true,
      showTxtCultivo:false,

      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'dni_trabajador',
          label: 'DNI',
          sortable: true
        },
        {
          key: 'nombre_trabajador',
          label: 'NOMBRE TRABAJADOR',
          sortable: true
        },
        {
          key: 'apellido_trabajador',
          label: 'APELLIDO TRABAJADOR',
          sortable: true
        },
        {
          key: 'estado',
          label: 'Estado',
          sortable: true
        },
        {
          key: 'acciones'
        },
      ],
      items: [],
      status: [
        {
          1: 'Activo',
          0: 'Inactivo',
        },
        {
          1: 'light-success',
          0: 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: 1, text: "Activo"},
        {value: 0, text: "Inactivo"}
      ],
      cultivo_Selected:null,
      cultivo_:[],
      grupoSelected:null,
      grupo:[],
      codigo: '',
      nombre: '',
      estado: {value: 1, text: "Activo"},
      id: 0,
      tipo: 0,
      fuente:'',
      txtCultivo:'',
      txtGrupo:'',
      archivo_excel: null,
      loadingCarga: false,
      loadingPlantilla:false,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.traerActividad();
  },
  methods: {
    traerActividad(){
      var yo = this

      yo.loading = true
      var config = {
        method: 'get',
        url: '/cosecha/cosecha/excluidos/list/all/'
      };

      axiosIns(config)
          .then(function (response) {
            yo.items = response.data.respuesta;
            yo.totalRows = yo.items.length
            console.log(yo.items);
          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){
        yo.loading = false
      });
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    mostrarModal(tipo, id,codigo, nombre, estado,cultivo,grupo,fuente){
      this.tipo = tipo
      this.estadoModal = true

      if (this.tipo === 1 ){
        this.infoModal.title = 'Registrar Actividad'
        this.infoModal.boton = 'Registar'
        this.showTxtGrupo = false;
        this.showCboGrupo = true;
        this.showTxtCultivo = false;
        this.showCboCultivo = true;
      }
      else if (this.tipo === 2 ){
        this.infoModal.title = 'Editar Actividad'
        this.infoModal.boton = 'Editar'
        this.showTxtGrupo = true;
        this.showCboGrupo = false;
        this.showTxtCultivo = true;
        this.showCboCultivo= false;

        this.id = id
        this.codigo = codigo
        this.nombre = nombre
        this.txtCultivo = cultivo
        this.txtGrupo = grupo
        this.fuente = fuente

        this.estado = {value: parseInt(estado), text: estado === '1' ? 'Activo' : 'Inactivo'}
      }
    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: 5000
          })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

    validarFormulario() {
      const valid = this.$refs.form.checkValidity()
      this.validacion = valid
      return valid
    },

    resetModal() {

      this.codigo = ''
      this.nombre = ''
      this.estado = {value: 1, text: "Activo"}
      this.cultivo_Selected = this.cultivo_[0].value
      this.fuente = ''
      this.validacion = null
      this.resetInfoModal()
    },

    okModal(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormulario()
    },

    eliminarRegistro(id, actividad){
      var yo = this

      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres eliminar al trabajador excluido: " + actividad + "?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          var config = {
            method: 'delete',
            url: '/cosecha/cosecha/excluidos/eliminar/' + id,
            headers: { }
          };

          axiosIns(config)
              .then(function (response) {
                if (response.status === 204){
                  yo.traerActividad();
                  yo.mostrarNotificacion('Registro eliminado', 'CheckIcon', 'La trabajador excluido ha sido eliminado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                }
              })
              .catch(function (error) {
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
              });
        }
      })
    },

    descargarFilePlantilla(){
      var yo = this
      this.loadingPlantilla = true
      var config = {
        method: 'post',
        url: '/cosecha/cosecha/excluidos/plantilla/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              console.log("Enviado")

              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Plantilla_Tr_excluidos.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
            else if(response.status === 204){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'No se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingPlantilla = false
          });
    },
    enviarExcelMasivos(){
      const yo = this

      this.$refs.formularioImportarTemas.validate().then(success => {
        if (success) {
          yo.loadingCarga = true
          const data = new FormData();
          data.append('file', yo.archivo_excel)
          data.append('area_gestion', "COSECHA")

          console.log(data);

          const config = {
            method: 'post',
            url: '/cosecha/cosecha/importExcelTrabajador_excluido/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data : data
          };

          axiosIns(config)
              .then(function (response) {
                console.log(response.data);
                if(response.status === 200){
                  let total_registro =response.data['row'];
                  console.log(total_registro);
                  if(!response.data['is_error']){
                    yo.mostrarNotificacion('¡Registro Guardado!', 'CheckIcon', 'Se realizaron la creación de '+ total_registro +' excluidos.', 'success', 5000)
                    yo.traerActividad();
                  }else{
                    yo.mostrarNotificacion('Error en el registro', 'BellIcon', 'Hubo un error en el registro, intentelo nuevamente en unos minutos.\n '+response.data['message'].toString(), 'danger', 5000)

                  }


                }
              })
              .catch(function (error) {
                console.log(error);
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', 'Hubo un error en el registro, intentelo nuevamente en unos minutos.\n '+error.toString(), 'danger', 5000)
              })
              .finally(function () {
                yo.archivo_excel = null
                yo.loadingCarga = false
                yo.$nextTick(() => {
                  yo.$refs['modal_importar'].toggle('#toggle-btn')
                })
              })
          ;
        }
      })
    },
    importarOk(bvModalEvtImp) {
      // Prevent modal from closing
      bvModalEvtImp.preventDefault()
      // Trigger submit handler
      this.enviarExcelMasivos()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
